import { combineReducers } from 'redux'
import approved from './approved'

export default combineReducers({
  approved,
})
